import { render, staticRenderFns } from "./createpurchasing.vue?vue&type=template&id=310d09ae&"
import script from "./createpurchasing.vue?vue&type=script&lang=js&"
export * from "./createpurchasing.vue?vue&type=script&lang=js&"
import style0 from "./createpurchasing.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports